import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const triggerRefresh = () => {
  /*document.addEventListener('lazyloaded', () => {
    ScrollTrigger.refresh()
    console.log('refresh')
  })*/
  window.addEventListener('load', () => {
    ScrollTrigger.refresh()
  })
}
triggerRefresh()
